export default "__VITE_ASSET__B62yXBny__"